export const TEMPLATE_CREATE_MAIL_TEMPLATE_BEGIN = 'TEMPLATE_CREATE_MAIL_TEMPLATE_BEGIN';
export const TEMPLATE_CREATE_MAIL_TEMPLATE_SUCCESS = 'TEMPLATE_CREATE_MAIL_TEMPLATE_SUCCESS';
export const TEMPLATE_CREATE_MAIL_TEMPLATE_FAILURE = 'TEMPLATE_CREATE_MAIL_TEMPLATE_FAILURE';
export const TEMPLATE_CREATE_MAIL_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_CREATE_MAIL_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_CREATE_SMS_TEMPLATE_BEGIN = 'TEMPLATE_CREATE_SMS_TEMPLATE_BEGIN';
export const TEMPLATE_CREATE_SMS_TEMPLATE_SUCCESS = 'TEMPLATE_CREATE_SMS_TEMPLATE_SUCCESS';
export const TEMPLATE_CREATE_SMS_TEMPLATE_FAILURE = 'TEMPLATE_CREATE_SMS_TEMPLATE_FAILURE';
export const TEMPLATE_CREATE_SMS_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_CREATE_SMS_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_ALL_SMS_TEMPLATE_BEGIN = 'TEMPLATE_FETCH_ALL_SMS_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_ALL_SMS_TEMPLATE_SUCCESS = 'TEMPLATE_FETCH_ALL_SMS_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_ALL_SMS_TEMPLATE_FAILURE = 'TEMPLATE_FETCH_ALL_SMS_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_ALL_SMS_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_FETCH_ALL_SMS_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_BEGIN = 'TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_SUCCESS = 'TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_FAILURE = 'TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_FETCH_ALL_MAIL_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_TEMPLATE_BEGIN = 'TEMPLATE_FETCH_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_TEMPLATE_SUCCESS = 'TEMPLATE_FETCH_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_TEMPLATE_FAILURE = 'TEMPLATE_FETCH_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_TEMPLATE_DISMISS_ERROR = 'TEMPLATE_FETCH_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_UPDATE_TEMPLATE_BEGIN = 'TEMPLATE_UPDATE_TEMPLATE_BEGIN';
export const TEMPLATE_UPDATE_TEMPLATE_SUCCESS = 'TEMPLATE_UPDATE_TEMPLATE_SUCCESS';
export const TEMPLATE_UPDATE_TEMPLATE_FAILURE = 'TEMPLATE_UPDATE_TEMPLATE_FAILURE';
export const TEMPLATE_UPDATE_TEMPLATE_DISMISS_ERROR = 'TEMPLATE_UPDATE_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_LOAD_COLLECTIONS_BEGIN = 'TEMPLATE_LOAD_COLLECTIONS_BEGIN';
export const TEMPLATE_LOAD_COLLECTIONS_SUCCESS = 'TEMPLATE_LOAD_COLLECTIONS_SUCCESS';
export const TEMPLATE_LOAD_COLLECTIONS_FAILURE = 'TEMPLATE_LOAD_COLLECTIONS_FAILURE';
export const TEMPLATE_LOAD_COLLECTIONS_DISMISS_ERROR = 'TEMPLATE_LOAD_COLLECTIONS_DISMISS_ERROR';
export const TEMPLATE_DELETE_TEMPLATE_BEGIN = 'TEMPLATE_DELETE_TEMPLATE_BEGIN';
export const TEMPLATE_DELETE_TEMPLATE_SUCCESS = 'TEMPLATE_DELETE_TEMPLATE_SUCCESS';
export const TEMPLATE_DELETE_TEMPLATE_FAILURE = 'TEMPLATE_DELETE_TEMPLATE_FAILURE';
export const TEMPLATE_DELETE_TEMPLATE_DISMISS_ERROR = 'TEMPLATE_DELETE_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_CREATE_TOOLTIP_TEMPLATE_BEGIN = 'TEMPLATE_CREATE_TOOLTIP_TEMPLATE_BEGIN';
export const TEMPLATE_CREATE_TOOLTIP_TEMPLATE_SUCCESS = 'TEMPLATE_CREATE_TOOLTIP_TEMPLATE_SUCCESS';
export const TEMPLATE_CREATE_TOOLTIP_TEMPLATE_FAILURE = 'TEMPLATE_CREATE_TOOLTIP_TEMPLATE_FAILURE';
export const TEMPLATE_CREATE_TOOLTIP_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_CREATE_TOOLTIP_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_BEGIN =
  'TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_SUCCESS =
  'TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_FAILURE =
  'TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_FETCH_ALL_TOOLTIP_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_GET_PERMISSION_FLAGS_BEGIN = 'TEMPLATE_GET_PERMISSION_FLAGS_BEGIN';
export const TEMPLATE_GET_PERMISSION_FLAGS_SUCCESS = 'TEMPLATE_GET_PERMISSION_FLAGS_SUCCESS';
export const TEMPLATE_GET_PERMISSION_FLAGS_FAILURE = 'TEMPLATE_GET_PERMISSION_FLAGS_FAILURE';
export const TEMPLATE_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'TEMPLATE_GET_PERMISSION_FLAGS_DISMISS_ERROR';
export const TEMPLATE_CREATE_AGREEMENT_TEMPLATE_BEGIN = 'TEMPLATE_CREATE_AGREEMENT_TEMPLATE_BEGIN';
export const TEMPLATE_CREATE_AGREEMENT_TEMPLATE_SUCCESS =
  'TEMPLATE_CREATE_AGREEMENT_TEMPLATE_SUCCESS';
export const TEMPLATE_CREATE_AGREEMENT_TEMPLATE_FAILURE =
  'TEMPLATE_CREATE_AGREEMENT_TEMPLATE_FAILURE';
export const TEMPLATE_CREATE_AGREEMENT_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_CREATE_AGREEMENT_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_BEGIN =
  'TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_SUCCESS =
  'TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_FAILURE =
  'TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_FETCH_ALL_AGREEMENT_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_BEGIN =
  'TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_SUCCESS =
  'TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_FAILURE =
  'TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_BEGIN =
  'TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_BEGIN';
export const TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_SUCCESS =
  'TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_SUCCESS';
export const TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_FAILURE =
  'TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_FAILURE';
export const TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_CREATE_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_BEGIN = 'TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_BEGIN';
export const TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_SUCCESS =
  'TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_SUCCESS';
export const TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_FAILURE =
  'TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_FAILURE';
export const TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_CREATE_SOCKET_IO_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_BEGIN =
  'TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_BEGIN';
export const TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_SUCCESS =
  'TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_SUCCESS';
export const TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_FAILURE =
  'TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_FAILURE';
export const TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_DISMISS_ERROR =
  'TEMPLATE_FETCH_ALL_SOCKET_IO_TEMPLATE_DISMISS_ERROR';
export const TEMPLATE_GENERATE_TEMPLATE_BEGIN = 'TEMPLATE_GENERATE_TEMPLATE_BEGIN';
export const TEMPLATE_GENERATE_TEMPLATE_SUCCESS = 'TEMPLATE_GENERATE_TEMPLATE_SUCCESS';
export const TEMPLATE_GENERATE_TEMPLATE_FAILURE = 'TEMPLATE_GENERATE_TEMPLATE_FAILURE';
export const TEMPLATE_GENERATE_TEMPLATE_DISMISS_ERROR = 'TEMPLATE_GENERATE_TEMPLATE_DISMISS_ERROR';
